module.exports = __webpack_public_path__ + "static/integration-5d3126a23b964452a4b0d6a898d94ff0.png";